module.exports = __webpack_public_path__ + "img/bn-w@2x.3e776471.png";